import Emitter from "./Emitter";

export default class RequestFullScreen extends Emitter {
    constructor(gb) {
        super(gb);
    }

    _default() {
        const fullScreenElement = document.createElement("div");
        fullScreenElement.setAttribute('id', 'full-screen-trigger');
        fullScreenElement.style = "position:fixed;top: 0;left:0;height:100%;width:100%;";
        document.querySelector("#gameContainer").append(fullScreenElement);

        const doc = window.document;
        const docEl = doc.documentElement;
        const requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;


        if (!doc.fullscreenElement && !this.fullScreenOnce) {
            const userAgent = navigator && navigator.userAgent ? navigator.userAgent.toLowerCase() : null;

            if (userAgent.indexOf("android") > -1) {
                fullScreenElement.addEventListener("touchend", toggleFullScreen)
            }

            // if (screen && screen.orientation) {
            //     screen.orientation.addEventListener('change', toggleFullScreen)
            // }
        }

        function toggleFullScreen() {
            event.stopPropagation();
            if(!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
                this.fullScreenOnce = true;
                requestFullScreen.call(docEl);
                fullScreenElement.removeEventListener('touchend', toggleFullScreen);
                // screen.orientation.removeEventListener('change', toggleFullScreen);
                fullScreenElement.remove();
            }
        }
    }
}
